import { render, staticRenderFns } from "./BookEventWorkshop.vue?vue&type=template&id=5640482c&"
import script from "./BookEventWorkshop.vue?vue&type=script&lang=js&"
export * from "./BookEventWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./BookEventWorkshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports